<style scoped>
.font-normal {
  font-weight: normal;
}
.f-weight {
  font-weight: bold;
}
.bank-item:first-child {
  margin-right: 10px;
}
.txt-right {
  text-align: right;
}

.page-title-txt {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
table {
  border-color: #bcbcbc;
  border-spacing: 0px;
  line-height: 30px;
  width: 100%;
  border-top: none;
  border-left: none;
  text-align: left;
}
table tr td,
.tdBg {
  /* border-bottom: none; */
  /* border-right: none; */
  border-color: #bcbcbc;
  padding: 0 6px;
}
.tdBg {
  background: #f3f3f3;
}
.tdCenter {
  text-align: center;
  border-right: none;
}
.page-write {
  text-align: left;
  /* padding: 106px 0; */
  box-sizing: border-box;
  font-weight: bold;
}
.page-write-item {
  width: 100%;
  height: 120px;
  /* border: 1px solid #bcbcbc; */
  padding-top: 5px;
  padding-left: 5px;
}

.page-title {
  padding-top: 30px;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0;
}
</style>
<template>
  <div class="printPage">
    <el-dialog
      title="打印预览"
      :visible.sync="showPrintDialog"
      width="900px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div :id="'printBillxx'" style="padding: 0 30px">
        <h1 id="myprinttd" class="page-title">
          {{ printData.taskType }}对账单
        </h1>
        <p class="page-title-txt" style="margin: 0; padding-top: 16px">
          尊敬的客户：
        </p>
        <p class="page-title-txt mb15">
          根据贵公司与我司所签订的服务协议，请贵公司确认以下费用明细，并进行相关款项支付，谢谢
        </p>
        <p class="txt-right">对账日期：{{ extradata.settleDate | getDate }}</p>
        <table border="1" class="mb30" style="width: 100%" v-if="isApproved">
          <tr>
            <td colspan="2" class="tdBg tdCenter" style="font-weight: 600">
              本期应付款总结算明细
            </td>
          </tr>
          <tr>
            <td class="tdBg" width="255">本期应付款合计金额（小写）：</td>
            <td class="t-right">
              {{
                printData.totalAmount
                  | adjustFilter(
                    printData.mantissaAmount,
                    printData.approveState
                  )
                  | numFmt
                  | numDigit
              }}
            </td>
          </tr>
          <tr>
            <td class="tdBg" width="255">本期应付款合计（大写）：</td>
            <td class="t-right">
              {{
                printData.totalAmount
                  | adjustFilter(
                    printData.mantissaAmount,
                    printData.approveState
                  )
                  | smallToBig
              }}
            </td>
          </tr>
        </table>

        <table class="mb30" border="1px">
          <thead>
            <th style="width: 90px" class="t-center tdBg tdCenter">序号</th>
            <th style="width: 210px" class="t-center tdBg tdCenter">
              任务类型
            </th>
            <th style="width: 150px" class="t-center tdBg tdCenter">数量</th>
            <th style="width: 150px" class="t-center tdBg tdCenter">单价</th>
            <th style="width: 150px" class="t-center tdBg tdCenter">
              单价单位
            </th>
            <th style="width: 150px" class="t-center tdBg tdCenter">备注</th>
          </thead>
          <tr v-for="(o, idx) in printData.settleDetails" :key="idx">
            <td class="t-center">{{ idx + 1 }}</td>
            <td class="">{{ o.taskContent || "-" }}</td>
            <td class="t-center">{{ o.qty || "-" }}</td>
            <td class="t-center">{{ o.taskPrice || "-" }}</td>
            <td class="t-center">
              {{ o.taskPriceUnit || "-" }}
            </td>
            <td class="t-center">{{ o.remark || "-" }}</td>
          </tr>
        </table>

        <div style="flex: 1">
          <table border="1px" class="mb15">
            <tr>
              <th class="tdBg" style="width: 150px">合计任务金额(元)：</th>
              <td class="t-right">
                {{ printData.totalTaskAmount | numFmt | numDigit }}
              </td>
            </tr>

            <tr v-if="isApproved">
              <th>考核得分：</th>
              <td class="font-normal t-right">
                {{ printData.assessmentScore || "-" }}
              </td>
            </tr>
            <tr v-if="extradata.isShowServiceFee == 'Y' && isApproved">
              <th>服务费(元)：</th>
              <td class="font-normal t-right">
                {{ printData.serviceAmount | numFmt | numDigit }}
              </td>
            </tr>
            <tr v-if="isApproved">
              <th>尾数调整(元)</th>
              <td class="font-normal t-right">
                {{ printData.mantissaAmount | numFmt | numDigit }}
              </td>
            </tr>
            <tr v-if="isApproved">
              <th>本期应付金额(元)：</th>
              <td class="font-normal t-right">
                {{ printData.totalAmount | adjustFilter(printData.mantissaAmount, printData.approveState) | numFmt | numDigit }}
              </td>
            </tr>
          </table>
        </div>
        <div style="width: 100%; display: flex">
          <div style="flex: 1; margin-right: 10px">
            <p class="page-title-txt mb15">支付账户信息如下：</p>
            <table border="1px" class="mb15">
              <tr>
                <td class="tdBg" width="100">开户名称：</td>
                <td class="t-left">
                  {{ extradata.tenantContractBank?.tenantName || "-" }}
                </td>
              </tr>

              <tr>
                <td class="tdBg" width="100">开户银行：</td>
                <td class="t-left" style="height: 40px; line-height: 20px">
                  {{ printData.curPayBankInfoJson.bankName || "-" }}
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="100">银行账号：</td>
                <td class="t-left">
                  {{ printData.curPayBankInfoJson.bankAccount || "-" }}
                </td>
              </tr>
            </table>

            <div class="page-write" style="width: 800px; display: flex">
              <div class="page-write-item">申请单位（盖章）：</div>
              <div class="page-write-item">审核单位（盖章）：</div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closePrint" style="color: #4fa1a4"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="billPrintClick"
          style="color: #fff"
          >打 印</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import print from 'print-js';
import printJS from "../../../../assets/js/print.min.js";
import { saveAs } from "file-saver";
import htmlDocx from "html-docx-js/dist/html-docx";
export default {
  name: "printPage",
  props: {
    showPrintDialog: {
      type: Boolean,
      default: false,
    },
    printData: {
      //内容
      type: Object,
      default: {},
    },

    extradata: {
      //内容
      type: Object,
      default: {},
    },
    isApproved: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sendCopy: "",
      staffName: null,
    };
  },
  filters: {
    adjustFilter(value, amount, state) {
      let num = Number(value);
      console.log("value", value, amount, state);
      if (state == "N" && !isNaN(amount)) {
        num = Number(value) + Number(amount);
      }

      return num;
    },
    // adjustFilter(value,amount,list,state) {
    //   let num = Number(value)
    //   if(state=='N'){//草稿中的状态才需要加尾数调整
    //       if(list&&list.length>0){//结算单信息里的结算总额
    //           list.forEach(item=>{
    //               console.log('/',item.mantissaAmount);
    //               let mantissaAmount=Number(item.mantissaAmount)
    //               if(mantissaAmount&&!isNaN(item.mantissaAmount)){
    //                   console.log('p',mantissaAmount);
    //                   num += mantissaAmount
    //               }
    //           })
    //       }else{
    //           if(!isNaN(amount)){
    //               num=Number(value) +Number(amount)
    //           }
    //       }
    //       console.log('value',value,amount,list);
    //   }
    //   return num
    // }
  },
  created() {
    let userInfo = JSON.parse(localStorage.userInfo);
    this.staffName = userInfo.staffName;
  },
  methods: {
    fmoney(num) {
      if (!num) {
        return "0.00";
      }
      num = num.toString().replace(/\$|\,/g, "");
      if (isNaN(num)) num = "0";
      var sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      var cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) cents = "0" + cents;
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
        num =
          num.substring(0, num.length - (4 * i + 3)) +
          "," +
          num.substring(num.length - (4 * i + 3));
      return (sign ? "" : "-") + num + "." + cents;
    },
    getAmount(res) {
      if (!res) return "-";
      var list = [];
      var res = JSON.parse(res);
      res.forEach((item, index) => {
        list.push(`${item.costTypeName}${this.fmoney(item.costAmount)}元`);
      });
      return list.join("、");
    },
    getGoodsName(res) {
      if (!res) return;
      var list = [];
      var res = JSON.parse(res);
      res.forEach((item, index) => {
        list.push(
          `${item.name}<span style="color:#9F9F9F;font-size:14px !important;">(${item.goodsSpec})</span>`
        );
      });
      return list.join("、");
    },
    getDocorName(res) {
      if (!res) return;
      if (res.indexOf("name") > -1) {
        var list = [];
        var res = JSON.parse(res);
        if (res.length >= 2) {
          res.forEach((item, index) => {
            list.push(item.name);
          });
          return list.join("、");
        } else {
          return res[0].name;
        }
      } else {
        return res;
      }
    },
    // 导出 word 文档
    exportDocx() {
      let arr = document.querySelector("#printBill"); //获取dom
      let html = arr.innerHTML; //获取html的内容
      let htmlStr = `
      <!DOCTYPE html>
      <html lang="en">
        <body>
          ${html}
        </body>
      </html>`; //把获取到的html放入到原生的html中
      saveAs(
        htmlDocx.asBlob(htmlStr, { orientation: "landscape" }),
        "付款通知书.doc"
      ); // 导出为word
    },
    //关闭打印
    closePrint() {
      this.$emit("closePrint");
    },
    billPrintClick() {
      const style = "@page {margin:0 10mm}"; //打印时去掉眉页眉尾
      printJS({
        printable: "printBillxx", // 标签元素id
        type: "html",
        // header: '',
        // documentTitle: str,
        targetStyles: ["*"],
        // scanStyles: true,
        style,
      });
      //各个配置项
      //printable:要打印的id。
      //type:可以是 html 、pdf、 json 等。
      //properties:是打印json时所需要的数据属性。
      //gridHeaderStyle和gridStyle都是打印json时可选的样式。
      //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
      //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
      //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
      //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
      //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
      // this.closePrint();
    },
    // 处理数据
    caCodeToDesc(listStr) {
      if (listStr != "") {
        listStr = listStr
          .replace(/\"/g, "")
          .replace(/[\\]/g, "")
          .replace(/\[/g, "")
          .replace(/\]/g, "")
          .replace(/\,/g, "；");
        console.log(listStr);
        return listStr;
      }
    },
    changeEnter(content) {
      if (content == "" || content == null) {
        return "无";
      } else {
        content = content.replace(/\n/g, "</br>");
        return content;
      }
    },
  },
};
</script>
